import { CloudUploadIcon } from "@bvhi/ui-icons";
import { ButtonProps, Button as MuiButton, styled, Typography } from "@mui/material";
import { forwardRef } from "react";
import { Control, Controller } from "react-hook-form";
import { Grid } from "./Grid";

type Props = ButtonProps;

export const Button = forwardRef<HTMLButtonElement, Props>(({ children, ...props }: Props, ref) => (
  <MuiButton ref={ref} {...props}>
    {children}
  </MuiButton>
));
Button.displayName = "Button";

export function AnyComponentButton<C extends React.ElementType>({ children, ...props }: ButtonProps<C, { component?: C }>) {
  return <Button {...props}>{children}</Button>;
}

export type FormUploadButtonProps = {
  accept: string;
  name: string;
  control: Control;
  label?: string;
} & Props;

const HiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export const FormUploadButton = ({ name, control, accept, disabled, label = "", ...props }: FormUploadButtonProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onBlur, onChange, value }, fieldState: { error } }) => (
        <Grid alignItems="center" columnSpacing={2} container>
          <Grid xs={3}>
            <AnyComponentButton
              component="label"
              disabled={disabled}
              fullWidth
              role={undefined}
              size="medium"
              startIcon={<CloudUploadIcon />}
              variant="contained"
              {...props}
            >
              <span>{label}</span>
              <HiddenInput
                accept={accept}
                multiple={false}
                onBlur={onBlur}
                type="file"
                onChange={(event) => {
                  if (event.target.files && event.target.files.length > 0) onChange(event.target.files[0]);
                }}
                onClick={(event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
                  const element = event.target as HTMLInputElement;
                  element.value = "";
                }}
              />
            </AnyComponentButton>
          </Grid>
          <Grid xs={9}>
            <Typography variant="body2">{(value as { name: string })?.name ?? "Bitte wählen Sie eine Datei aus..."}</Typography>
          </Grid>
          <Grid xs={12}>
            <Typography color="error" variant="body2">
              {!disabled && error ? error.message : " "}
            </Typography>
          </Grid>
        </Grid>
      )}
    />
  );
};
